/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import {Router} from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-confirm-delete-dialog',
  templateUrl: './confirm-delete-dialog.component.html'
})
export class ConfirmDeleteDialogComponent implements OnInit {

  @Output()
  confirmEvent = new EventEmitter<boolean>();

  displayName: string = null;
  elementNames: string[] = [];

  constructor(
    private mRouter: Router
  ) {}


  ngOnInit(): void {

  }

  show(displayName: string, elementNames: string[]): void {
    this.displayName = (elementNames.length == 1) ? displayName : displayName + "s";
    this.elementNames = elementNames;
    $("#confirm-delete-dialog").modal("show");
  }

  hide(): void {
    $("#confirm-delete-dialog").modal("hide");
  }

  confirm(): void {
    this.confirmEvent.emit(true);
  }

}
